module.exports = __webpack_public_path__ + "img/ch08_04_抹茶千层.605cc327.jpg";